import { Card, Checkbox, Form, Message } from "semantic-ui-react";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { action, observable } from "mobx";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import TourStatus from "./TourStatus";
import ModalTourNotAccessible from "./modals/ModalTourNotAccessible";
import TourUiMeet3dActiveLabel from "~/modules/PanelCommon/components/TourUiMeet3dActiveLabel";
import TourClientFacingStatus from "~/constants/Tour/TourClientFacingStatus";
import "../styles/TourIndexList.less";

@observer
class TourIndexList extends Component {
  @observable clickedTourId;

  @action
  tourOnClick(tour) {
    const { openTourCallback } = this.props;
    this.clickedTourId = tour.tourId;
    openTourCallback(tour);
  }

  toggleSelection(e, tourId, customerHasUrbanimmersiveGroupSpecialPricing) {
    e.stopPropagation();

    const { selectedTours, selectTourCallback, unselectTourCallback } = this.props;

    if (selectedTours.findIndex(item => item.tourId === tourId) === -1) {
      selectTourCallback(tourId, customerHasUrbanimmersiveGroupSpecialPricing);
    } else {
      unselectTourCallback(tourId);
    }
  }

  canUpdateIsActive(tour) {
    if (tour.clientFacingStatus === TourClientFacingStatus.ARCHIVED) {
      return false;
    }

    if (tour.clientFacingStatus === TourClientFacingStatus.INACTIVE) {
      return tour.customerHasUrbanimmersiveGroupSpecialPricing;
    }

    return (
      [TourClientFacingStatus.PHOTOS_READY, TourClientFacingStatus.PUBLISHED].indexOf(tour.clientFacingStatus) > -1
    );
  }

  render() {
    const {
      tours,
      showTourNotAccessibleModal,
      closeTourNotAccessibleModalCallback,
      clearSearch,
      t,
      selectedTours,
    } = this.props;

    return (
      <>
        {tours.length > 0 ? (
          <>
            <Card.Group itemsPerRow={4} className="ui doubling">
              {tours.map((tour, i) => (
                <Card
                  // eslint-disable-next-line react/no-array-index-key
                  key={i}
                  className="tour-card-pointer"
                  title={t("clientPanelMisc:titleTourAddress", { street: tour.address.street })}
                  onClick={() => this.tourOnClick(tour)}
                >
                  <Card.Content
                    style={
                      !tour.isArchived && tour.posterThumbnailLarge
                        ? { background: `url(${tour.posterThumbnailLarge}) no-repeat center center` }
                        : null
                    }
                    className={
                      !tour.isArchived && tour.posterThumbnailLarge
                        ? "card-has-thumbnail-background"
                        : "card-no-thumbnail-background"
                    }
                  >
                    <Card.Description>
                      {this.canUpdateIsActive(tour) && (
                        <Form.Field
                          onClick={e =>
                            this.toggleSelection(e, tour.tourId, tour.customerHasUrbanimmersiveGroupSpecialPricing)
                          }
                        >
                          <Checkbox checked={selectedTours.findIndex(item => item.tourId === tour.tourId) > -1} />
                        </Form.Field>
                      )}
                      <TourStatus tour={tour} useDescription />
                      <TourUiMeet3dActiveLabel tour={tour} />

                      {tour.isArchived || !tour.posterThumbnailLarge ? (
                        <div className="no-thumbnail-div">
                          <span className="no-thumbnail-message">{t("noThumbnailAvailable")}</span>
                        </div>
                      ) : null}
                    </Card.Description>
                  </Card.Content>
                  <Card.Content>
                    <Card.Header textAlign="center" className="card-header">
                      {tour.address.street2 ? (
                        <>
                          {tour.address.street} <br />
                          {tour.address.street2}
                        </>
                      ) : (
                        tour.address.street
                      )}
                    </Card.Header>
                  </Card.Content>
                </Card>
              ))}
            </Card.Group>
            <ModalTourNotAccessible
              clickedTour={tours.find(element => element.tourId === this.clickedTourId)}
              showModal={showTourNotAccessibleModal}
              closeModalCallback={closeTourNotAccessibleModalCallback}
            />
          </>
        ) : (
          <Message size="huge" className="no-tour-found">
            <Message.Header>{t("clientPanelMisc:noToursMatchedSearch")}</Message.Header>
            <p>
              {t("searchAgainOr")}{" "}
              <span className="clear-search-no-tour-found" onClick={clearSearch}>
                {t("clearYourSearch")}
              </span>{" "}
              {t("clientPanelMisc:toSeeAllYourTours")}
            </p>
          </Message>
        )}
      </>
    );
  }
}

TourIndexList.propTypes = {
  tours: PropTypes.array,
  openTourCallback: PropTypes.func.isRequired,
  showTourNotAccessibleModal: PropTypes.bool.isRequired,
  closeTourNotAccessibleModalCallback: PropTypes.func.isRequired,
  clearSearch: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  selectedTours: PropTypes.array.isRequired,
  selectTourCallback: PropTypes.func.isRequired,
  unselectTourCallback: PropTypes.func.isRequired,
};

export default withTranslation()(TourIndexList);
